import { sleep } from '@/utils';
import BaseService from '../base';
import { ILiveIndexRequest, ILiveIndexResponseData } from './types';

class HomeService extends BaseService {

  // 第一页: cursor=0 ,
  async getLiveIndex(cursor = 0, cursor_size = 50) {
    const url = '/web/live/index';
    const params: ILiveIndexRequest = {
      cursor,
      cursor_size,
    };
    return this.get({ url, params });
  }

}

const homeService = new HomeService();

export default homeService;